// Set on <html> for the duration of a nonce redemption. Written by the inline
// script below before the page paints, read by login-nonce-overlay.scss to
// cover the pre-rendered signed-out markup, and cleared by LoginNonceOverlay
// once React has a real overlay on screen.
export const LOGIN_NONCE_PREFLIGHT_ATTRIBUTE = 'data-redeeming-login-nonce';

// Kept in sync with LOGIN_NONCE_HASH_KEY in firebaseApp.ts. This script has to
// run before the bundle that owns that constant exists, so it cannot import it.
const HASH_KEY = 'loginNonce';

// Runs from an inline <head> script (see gatsby-ssr.tsx), which is the only
// thing that executes before the pre-rendered body paints. The timeout is a
// dead man's switch: if the bundle never runs there is no React to clear the
// attribute, and a permanently hidden page is worse than the flash this
// prevents.
//
// Parses the fragment with URLSearchParams rather than a substring search, so
// this matches redeemLoginNonceFromUrl's own parsing in firebaseApp.ts and
// does not fire on a fragment that merely contains the text "loginNonce="
// inside some other value.
export const LOGIN_NONCE_PREFLIGHT_SCRIPT = `
try {
  var hashParams = new URLSearchParams(location.hash.replace(/^#/, ''));
  if (hashParams.get('${HASH_KEY}')) {
    var el = document.documentElement;
    el.setAttribute('${LOGIN_NONCE_PREFLIGHT_ATTRIBUTE}', '');
    setTimeout(function () { el.removeAttribute('${LOGIN_NONCE_PREFLIGHT_ATTRIBUTE}'); }, 20000);
  }
} catch (e) {}
`.trim();
